/** Funtions to assist with the filtering of options
 * using the criteria of number of stops.
 */
import { List, Map, OrderedMap, Set } from 'immutable'

/** Produces a Map, keyed by stop count (which, note, is different
 * to connecting flights) indicating for each stop count
 * the cheapest price for that offer. */
export const createStopsIndex = (offers = List()) =>
    offers.reduce( (idx, offer) => {
        const offerCost = offer.getIn(['cost','amount'])
        return offer.get('serviceDetail', List()).reduce( (idx, s) =>
            idx.update( countStops(s), (stopInfo = Map()) =>
                stopInfo.update('lowest', prevLow => {
                    return prevLow == null || offerCost < prevLow
                        ? offerCost
                        : prevLow
                })
                    .update( 'highest', prevHigh => {
                        return prevHigh == null || offerCost > prevHigh
                            ? offerCost
                            : prevHigh
                    })
            ),idx)
    }, OrderedMap()).sortBy((v,k)=>k,(a,b)=>a-b)


/** Counts number of stops for a service */
export const countStops = (serviceDetail = Map()) =>
    Math.max(0, serviceDetail.get('connectingFlightDetail', List()).size - 1)


/** For the given seq of stop counts (e.g. Set.of(0,2)) produces a predicate
 * function that only matches offers where every flight matches at
 * least one of the stop options, unless the stopCounts are empty,
 * in which case an offer always matches.
 */
export const stopsPredicate = (stopCounts = Set()) => (offer = Map()) =>
    // stopCounts.isEmpty() ||  // This lets all options through upon no selection
    offer.has('serviceDetail') ?
    offer.get('serviceDetail').some( sd =>
        stopCounts.includes( countStops(sd) ) ) :
    offer.has('serviceAlternatives') ? offer.get('serviceAlternatives').some( sa => sa.get('serviceDetail').some(sd => stopCounts.includes( countStops(sd) ))): false



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/stops/stops.js